<template>
  <FlotoModule>
    <RouterView :key="$route.fullPath" />
  </FlotoModule>
</template>

<script>
import { LicenseComputed } from '@state/modules/license'
import { PreferenceComputed } from '@state/modules/preference'

export default {
  name: 'AiManagementModule',
  page() {
    return {
      title: this.$tc('ai'),
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.myAllowedModules.indexOf('admin.ai') === -1) {
        return vm.$router.replace({ name: '404' })
      }
      if (!vm.aiEnabled) {
        return next({ name: '404' })
      }
    })
  },
  data() {
    return {}
  },
  computed: {
    ...LicenseComputed,
    ...PreferenceComputed,
  },
  created() {
    if (this.myAllowedModules.indexOf('admin.ai') === -1) {
      return this.$router.replace({ name: '404' })
    }
    if (!this.aiEnabled) {
      return this.$router.replace({ name: '404' })
    }
  },
}
</script>
